import { Component, OnInit, Inject } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-convention-room-dialog',
  templateUrl: './convention-room-dialog.component.html',
  styleUrls: ['./convention-room-dialog.component.scss']
})
export class ConventionRoomDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();
  public roomForm: FormGroup;
  public isEdit: boolean
  
  constructor(
    private fb: FormBuilder,
    public matDialogRef: MatDialogRef<ConventionRoomDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

      if (this.data.id === '0') {
        this.isEdit = false
      } else {
        this.isEdit = true
      }

      this.roomForm = this.createRoomForm(this.data)

     }

  ngOnInit() {
  }

  createRoomForm (data) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(data.id),
      name: new FormControl(data.name),
    });
    return form
  }


}
